import React from 'react'
import MaterialSymbol from '../material-symbol'

const CalendarMonth = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="calendar_month" {...props} />
))

CalendarMonth.displayName = 'CalendarMonth'

export default CalendarMonth
